import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import {
  Location,
  NavigateFunction,
  useLocation,
  useNavigate,
} from 'react-router-dom'
import type { Track } from 'types/track'
import { TRACK } from '@disco/constants/ItemTypes'
import { getExplorerSelectedItems } from '@disco/state-management/selectors/selection'
import BulkEditor from 'components/bulk-editor'
import type { Playlist } from 'types/playlist'
import type { Artist } from 'types/artist'
import type { RootState } from 'store/configureStore'
import { getSelectionReturnPath } from 'utils/routing'

const mapStateToProps = (state: RootState) => {
  const items = getExplorerSelectedItems(state)
  return {
    selectedItems: items.filter(item => {
      if (!('type' in item) || item.type !== TRACK) return true
      return !(item as Track).outside_your_territories
    }),
  }
}

type Props = {
  selectedItems: (Track | Playlist | Artist)[]
  navigate: NavigateFunction
  location: Location
}

class ExplorerBulkEdit extends React.Component<Props> {
  _getReturnPath() {
    return getSelectionReturnPath(this.props.location.pathname)
  }

  componentDidMount() {
    if (this.props.selectedItems.length === 0) {
      this.props.navigate(this._getReturnPath())
    }
  }

  _onClose = () => {
    this.props.navigate(this._getReturnPath())
  }

  render() {
    if (this.props.selectedItems.length === 0) return null
    return (
      <BulkEditor
        editing={{
          tracks: this.props.selectedItems.filter(
            item => 'type' in item && item.type === TRACK,
          ) as Track[],
        }}
        onRequestClose={this._onClose}
      />
    )
  }
}

const mapDispatchToProps = {}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

const ConnectedExplorerBulkEdit = connector(ExplorerBulkEdit)

const ExplorerBulkEditWithNavigation = (props: any) => {
  const navigate = useNavigate()
  const location = useLocation()
  return (
    <ConnectedExplorerBulkEdit
      {...props}
      navigate={navigate}
      location={location}
    />
  )
}

export default ExplorerBulkEditWithNavigation
